import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { RootState } from '../index';
import { newUsers } from '../users/selectors';
import { selectBUs } from '../selectData/selectors';

// const viewProjectModal = (state: RootState) => state.modals.viewProject;
const viewProjectId = (state: RootState) => state.modals.viewProjectId;
const viewUserModal = (state: RootState) => state.modals.viewUser;
const viewUserId = (state: RootState) => state.modals.viewUserId;

const selectViewUserModal = createDraftSafeSelector(
  viewUserModal,
  (viewModal) => viewModal,
);

const selectProjectStatusModal = (state: RootState): boolean =>
  state.modals.projectStatusModal;

const selectViewUserId = createDraftSafeSelector(
  [viewUserId, newUsers, selectBUs],
  (id, users, bus) => {
    const user = users.find((user) => user.id === id);
    const countries = user?.countries.includes('All')
      ? user?.countries
      : user?.countries.map((country) => {
          const countryToSearch =
            country?.toUpperCase() === 'UK' ? 'GB' : country;
          const bu = bus.find((bu) => bu?.countryId === countryToSearch);
          return {
            countryId: bu?.countryId || countryToSearch,
            countryName: bu?.countryName || countryToSearch,
          };
        });
    return user && { ...user, countries };
  },
);

export const selectSolutionTypeModal = (state: RootState) =>
  state.modals.solutionTypeModal;
export const selectCreateProjectImproveModal = (state: RootState) =>
  state.modals.createProjectImproveModal;
export const selectMsTeamsModal = (state: RootState) =>
  state.modals.msTeamsModal;

export {
  viewProjectId,
  selectViewUserModal,
  selectViewUserId,
  selectProjectStatusModal,
};
